import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Image, ResponsiveEmbed } from 'react-bootstrap';

import Loading from '../loading/Loading';

const IMAGE_DOCUMENT = "IMAGE_DOCUMENT";
const PDF_DOCUMENT = "PDF_DOCUMENT";

class Media extends Component {
    
    render() {
        const {
            src,
            isDisplayed = false
        } = this.props;


        if (!isDisplayed) {
            return null;
        }

        return (
                <div id="mediaViewer">
                    <Loading isLoading={Boolean(!src)}/>
                    
                    {this.renderMedia()} 
                            
                </div>
                );
    }

    renderMedia() {
        const { src } = this.props;
        let type = this.determineType(src);
        
        switch (type){
            case PDF_DOCUMENT: 
                return (
                        <ResponsiveEmbed a16by9>
                                <embed type="application/pdf" src={src} />
                        </ResponsiveEmbed>
                        );
                break;
            default:
            case IMAGE_DOCUMENT:
                return (
                        <Image src={src} responsive/>
                        );
                break;
        }
    }
    
    determineType(src) {
        if(src.match(/\.(jpg|jpeg|png|gif|image)/)) {
            return IMAGE_DOCUMENT;
        }
        if(src.match(/\.(pdf)/)) {
            return PDF_DOCUMENT;
        }
    }

}

Media.propTypes = {
    src: PropTypes.string,
    isDisplayed: PropTypes.bool,
};

export default Media;